export default function ChatPopupIcon(props) {
  return (
    <svg
      width="77"
      height="88"
      viewBox="0 0 77 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_f_5_17)">
        <path
          d="M38.8393 80.8982C56.2554 80.8982 70.3739 79.5787 70.3739 77.9511C70.3739 76.3234 56.2554 75.0039 38.8393 75.0039C21.4232 75.0039 7.30469 76.3234 7.30469 77.9511C7.30469 79.5787 21.4232 80.8982 38.8393 80.8982Z"
          fill="url(#paint0_radial_5_17)"
        />
      </g>
      <mask
        id="mask0_5_17"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="2"
        y="0"
        width="74"
        height="74"
      >
        <path
          d="M38.8395 73.679C59.1854 73.679 75.679 57.1854 75.679 36.8395C75.679 16.4936 59.1854 0 38.8395 0C18.4936 0 2 16.4936 2 36.8395C2 57.1854 18.4936 73.679 38.8395 73.679Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_5_17)">
        <path
          d="M38.8395 73.679C59.1854 73.679 75.679 57.1854 75.679 36.8395C75.679 16.4936 59.1854 0 38.8395 0C18.4936 0 2 16.4936 2 36.8395C2 57.1854 18.4936 73.679 38.8395 73.679Z"
          fill="url(#paint1_radial_5_17)"
        />
        <path
          d="M38.8395 73.679C59.1854 73.679 75.679 57.1854 75.679 36.8395C75.679 16.4936 59.1854 0 38.8395 0C18.4936 0 2 16.4936 2 36.8395C2 57.1854 18.4936 73.679 38.8395 73.679Z"
          fill="url(#paint2_radial_5_17)"
        />
        <path
          d="M38.8395 73.679C59.1854 73.679 75.679 57.1854 75.679 36.8395C75.679 16.4936 59.1854 0 38.8395 0C18.4936 0 2 16.4936 2 36.8395C2 57.1854 18.4936 73.679 38.8395 73.679Z"
          fill="url(#paint3_radial_5_17)"
        />
        <g filter="url(#filter1_f_5_17)">
          <path
            d="M38.9133 73.5316C59.2185 73.5316 75.6791 57.071 75.6791 36.7658C75.6791 16.4606 59.2185 0 38.9133 0C18.6081 0 2.14752 16.4606 2.14752 36.7658C2.14752 57.071 18.6081 73.5316 38.9133 73.5316Z"
            fill="url(#paint4_linear_5_17)"
            fillOpacity="0.6"
          />
        </g>
        <path
          d="M34.7635 31.2072H37.8955L42.9175 43.7892H39.6595L38.6515 41.1972H34.0075L32.9995 43.7892H29.7235L34.7635 31.2072ZM37.8595 38.7492L36.3295 34.5192L34.7815 38.7492H37.8595ZM44.1811 31.2072H47.3671V43.7892H44.1811V31.2072Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_5_17"
          x="0.820948"
          y="68.5202"
          width="76.0367"
          height="18.8618"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.24187"
            result="effect1_foregroundBlur_5_17"
          />
        </filter>
        <filter
          id="filter1_f_5_17"
          x="-71.5315"
          y="-73.679"
          width="220.89"
          height="220.89"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="36.8395"
            result="effect1_foregroundBlur_5_17"
          />
        </filter>
        <radialGradient
          id="paint0_radial_5_17"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(42.818 77.9511) rotate(168.944) scale(32.6565 261.137)"
        >
          <stop stopColor="#916421" />
          <stop offset="1" stopColor="#801EFF" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_5_17"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.8497 28.7348) rotate(114.341) scale(37.3607)"
        >
          <stop offset="0.350962" stopColor="#5709FA" />
          <stop offset="1" stopColor="#F6AF2B" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_5_17"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.1987 20.1144) rotate(56.3847) scale(46.9798)"
        >
          <stop stopColor="#5709FA" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_5_17"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(63.964 17.7566) rotate(135.22) scale(27.0916)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_5_17"
          x1="48.7862"
          y1="10.5361"
          x2="28.6719"
          y2="54.2277"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.6" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
